var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWolontariatIlustracjaKrzyz = function SvgWolontariatIlustracjaKrzyz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Wolontariat_ilustracja_krzyz_svg__Warstwa_1",
    "data-name": "Warstwa 1",
    viewBox: "0 0 98.58 98.58"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Wolontariat_ilustracja_krzyz_svg__cls-1{fill:#e41f13}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.53.13h15.53v15.53H41.53zM41.53 27.74h15.53v15.53H41.53zM41.53 55.34h15.53v15.53H41.53zM41.53 82.92h15.53v15.53H41.53zM82.92 41.53h15.53v15.53H82.92z",
    className: "Wolontariat_ilustracja_krzyz_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.31 41.53h15.53v15.53H55.31zM27.71 41.53h15.53v15.53H27.71zM.13 41.53h15.53v15.53H.13z",
    className: "Wolontariat_ilustracja_krzyz_svg__cls-1"
  })));
};
export default SvgWolontariatIlustracjaKrzyz;